<template>
  <div class="franchise-investment ptb-100">
    <div class="container">
      <!-- Marketing & Advertising -->
      <div class="content-title style-one text-center mb-50">
        <h6 class="section-subtitle" style="color: #d1d5db;">
          Marketing & <span style="color: #9ca3af;">Advertising</span>
        </h6>
      </div>
      <div class="row gx-4 mb-60">
        <div
          class="col-lg-12"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="timeline-section">
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <h4>Initial Marketing Support</h4>
                <p>
                  Until the franchise location reaches $100,000 in gross monthly revenue, Franchisor will provide and manage all marketing and promotional efforts.
                </p>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <h4>System Marketing Fund</h4>
                <p>
                  After reaching $100,000 in gross monthly revenue, Franchisee shall contribute 2% of gross sales toward a system-wide marketing and advertising fund.
                </p>
                <p>
                  Franchisee may also be required to conduct local marketing efforts as directed by Franchisor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Training & Opening Support -->
      <div class="content-title style-one text-center mb-50">
        <h6 class="section-subtitle" style="color: #d1d5db;">
          Training & Opening <span style="color: #9ca3af;">Support</span>
        </h6>
      </div>
      <div
        class="training-section mb-60"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="200"
      >
        <h4>Franchisor shall provide:</h4>
        <div class="training-list">
          <div class="training-item">
            <div class="training-dot"></div>
            <p>Initial training covering operations, food preparation, POS systems, brand standards, and compliance</p>
          </div>
          <div class="training-item">
            <div class="training-dot"></div>
            <p>Opening support, which may include on-site assistance during launch</p>
          </div>
          <div class="training-item">
            <div class="training-dot"></div>
            <p>Ongoing operational guidance as deemed necessary by Franchisor</p>
          </div>
        </div>
      </div>

      <!-- Franchisee Support & Training Details -->
      <div class="content-title style-one text-center mb-50">
        <h6 class="section-subtitle">
          Franchisee Support & <span>Training</span>
        </h6>
      </div>
      <div class="row gx-4 mb-60">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="support-card">
            <h3>Comprehensive Onboarding and Continuous Assistance</h3>
            <p>
              Guac & Grill offers a dual-phase training program encompassing classroom instruction and on-site guidance to ensure franchisees are well-equipped in operations, food preparation, branding, and marketing.
            </p>
            <p>
              The franchisor's team supports site selection and store build-out processes, easing entry barriers and accelerating launch timelines.
            </p>
            <p>
              Ongoing field support helps maintain brand standards, consistent menu quality, and local marketing momentum, while dedicated R&D efforts continuously evolve menu selections based on consumer trends and feedback.
            </p>
          </div>
        </div>
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="400"
        >
          <div class="support-card">
            <h3>Marketing and Technology Enablement</h3>
            <p>
              Franchisees receive professionally crafted launch materials and access to a unified digital platform integrating point-of-sale (POS) systems, mobile app ordering, and loyalty rewards.
            </p>
            <p>
              The brand's marketing strategy emphasizes both national reach and local community engagement initiatives, boosting visibility and customer retention from day one.
            </p>
            <p>
              Support for digital tools and data analytics empowers franchisees to optimize operations, streamline customer service, and maximize sales growth in competitive markets.
            </p>
          </div>
        </div>
      </div>

      <!-- Store Layout -->
      <div class="content-title style-one text-center mb-50">
        <h6 class="section-subtitle">
          GUAC N GRILL – <span>Isometric</span> Layout Overview
        </h6>
      </div>
      <div class="row gx-4">
        <div
          class="col-lg-4"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="layout-card">
            <div class="layout-label">Dining Area</div>
            <ul class="layout-list">
              <li>Large open central dining space designed for high turnover and easy reconfiguration</li>
              <li>Clear circulation paths improve ADA accessibility and staff movement</li>
              <li>Layout supports both dine-in and takeout demand without congestion</li>
              <li>Furniture placement maximizes seat count while maintaining comfort and code compliance</li>
            </ul>
          </div>
        </div>
        <div
          class="col-lg-4"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="400"
        >
          <div class="layout-card">
            <div class="layout-label">Front-of-House (Customer Zone)</div>
            <ul class="layout-list">
              <li>Direct street-facing entry leads guests immediately into the ordering and pickup zone</li>
              <li>Strategically positioned service counter near the entrance allows fast ordering and smooth queue management</li>
              <li>Open sightlines from entry to seating enhance perceived space and encourage dine-in traffic</li>
              <li>Seating includes a mix of 2-top tables and banquette seating, allowing flexible configurations</li>
            </ul>
          </div>
        </div>
        <div
          class="col-lg-4"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="600"
        >
          <div class="layout-card">
            <div class="layout-label">Back-of-House (Operational Core)</div>
            <ul class="layout-list">
              <li>Efficient rear service zone houses restrooms, storage, and utility spaces in a compact footprint</li>
              <li>Back-of-house placement minimizes disruption to customer areas while allowing fast staff access</li>
              <li>Dedicated storage areas reduce floor clutter and support higher inventory turnover</li>
              <li>Linear flow from kitchen to counter improves speed of service</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FranchiseInvestment",
});
</script>

<style lang="scss" scoped>
.franchise-investment {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  .mb-50 { margin-bottom: 50px; }
  .mb-60 { margin-bottom: 60px; }

  .timeline-section {
    position: relative;
    padding-left: 30px;
    &:before {
      content: '';
      position: absolute;
      left: 7px;
      top: 0;
      bottom: 0;
      width: 2px;
      background-color: #6b7280;
    }
    .timeline-item {
      position: relative;
      margin-bottom: 35px;
      &:last-child { margin-bottom: 0; }
      .timeline-dot {
        position: absolute;
        left: -30px;
        top: 5px;
        width: 16px;
        height: 16px;
        background-color: #6b7280;
        border-radius: 50%;
        z-index: 2;
      }
      .timeline-content {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 25px 30px;
        h4 {
          font-size: 16px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 12px;
        }
        p {
          font-size: 14px;
          color: #d1d5db;
          line-height: 1.7;
          margin-bottom: 10px;
          &:last-child { margin-bottom: 0; }
        }
      }
    }
  }

  .training-section {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 35px 30px;
    h4 {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 25px;
    }
    .training-list {
      .training-item {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        margin-bottom: 20px;
        &:last-child { margin-bottom: 0; }
        .training-dot {
          width: 14px;
          height: 14px;
          background-color: #6b7280;
          border-radius: 50%;
          flex-shrink: 0;
          margin-top: 4px;
        }
        p {
          font-size: 14px;
          color: #d1d5db;
          line-height: 1.7;
          margin-bottom: 0;
        }
      }
    }
  }

  .support-card {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 35px 30px;
    h4 {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 12px;
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        font-size: 14px;
        color: #d1d5db;
        line-height: 1.7;
        margin-bottom: 10px;
        padding-left: 20px;
        position: relative;
        &:before {
          content: "•";
          color: var(--secondaryColor);
          position: absolute;
          left: 0;
          font-weight: bold;
        }
        &:last-child { margin-bottom: 0; }
      }
    }
  }
}

@media (max-width: 991px) {
  .franchise-investment {
    .support-card,
    .layout-card {
      margin-bottom: 25px;
    }
  }
}
</style>
